import { render, staticRenderFns } from "./MatchImageText.vue?vue&type=template&id=1d786707&scoped=true&"
import script from "./MatchImageText.vue?vue&type=script&lang=js&"
export * from "./MatchImageText.vue?vue&type=script&lang=js&"
import style0 from "./MatchImageText.vue?vue&type=style&index=0&id=1d786707&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d786707",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d786707')) {
      api.createRecord('1d786707', component.options)
    } else {
      api.reload('1d786707', component.options)
    }
    module.hot.accept("./MatchImageText.vue?vue&type=template&id=1d786707&scoped=true&", function () {
      api.rerender('1d786707', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MatchImageText.vue"
export default component.exports